// extracted by mini-css-extract-plugin
module.exports = {"default":"anchor_default__fblYF","inner":"anchor_inner__Oqr2Y"};